function initCommencementBundleModal() {
  const dataEl = document.getElementById("commencement-bundles-data");
  const modal = document.getElementById("product-modal");
  const contentArea = document.getElementById("modal-content");

  if (!modal || !contentArea) {
    return;
  }

  let bundles = [];
  if (dataEl) {
    try {
      bundles = JSON.parse(dataEl.textContent || "[]");
    } catch (err) {
      console.warn("[commencement bundle] JSON parse error", err);
    }
  }
  if (!Array.isArray(bundles)) {
    bundles = [];
  }

  const bundleById = new Map();
  bundles.forEach((bundle) => bundleById.set(String(bundle.id), bundle));

  let placeholderImage = "";
  let showCadCurrency = false;
  const configEl = document.getElementById("commencement-bundles-config");
  if (configEl) {
    try {
      const config = JSON.parse(configEl.textContent || "{}");
      placeholderImage =
        config && config.placeholder_image ? String(config.placeholder_image) : "";
      showCadCurrency = Boolean(config && config.show_cad_currency);
    } catch (err) {
      console.warn("[commencement bundle] config JSON parse error", err);
    }
  }

  const currencyCodeHtml = () =>
    showCadCurrency ? '<span class="price-currency-code">CAD</span>' : "";

  const productImageUrl = (product) => {
    if (product && product.picture_url) {
      return String(product.picture_url);
    }
    return placeholderImage;
  };

  const moneyAmount = (value) => {
    const n = Number(value || 0);
    return `$${n.toFixed(2)}`;
  };

  const escapeHtml = (value) =>
    String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const productKey = (product) =>
    [
      product.parent_id,
      product.api_product_id || "",
      product.name || "",
      product.price || "",
    ].join("|");

  const getAjaxUrl = () =>
    (typeof ThemeJS !== "undefined" && ThemeJS?.Variables?.Ajax?.url) ||
    (typeof wc_add_to_cart_params !== "undefined" &&
      wc_add_to_cart_params?.ajax_url) ||
    "/wp-admin/admin-ajax.php";

  function normalizeAttrKeyForMatch(s) {
    return String(s || "")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function normalizeAttrAssocForMatch(obj) {
    const out = {};
    Object.keys(obj || {}).forEach((k) => {
      const v = obj[k];
      if (v === "" || v == null) {
        return;
      }
      out[normalizeAttrKeyForMatch(k)] = normalizeAttrKeyForMatch(v);
    });
    const sorted = {};
    Object.keys(out)
      .sort()
      .forEach((k) => {
        sorted[k] = out[k];
      });
    return sorted;
  }

  function attrAssocMapsEqual(a, b) {
    return (
      JSON.stringify(normalizeAttrAssocForMatch(a)) ===
      JSON.stringify(normalizeAttrAssocForMatch(b))
    );
  }

  function rowIsEnabled(row) {
    if (!row || typeof row !== "object") {
      return false;
    }
    let v;
    if (Object.prototype.hasOwnProperty.call(row, "is_enabled")) {
      v = row.is_enabled;
    } else if (Object.prototype.hasOwnProperty.call(row, "enabled")) {
      v = row.enabled;
    } else if (Object.prototype.hasOwnProperty.call(row, "isEnabled")) {
      v = row.isEnabled;
    } else {
      return true;
    }
    if (typeof v === "boolean") {
      return v;
    }
    if (v === 0 || v === "0") {
      return false;
    }
    if (v === 1 || v === "1") {
      return true;
    }
    if (typeof v === "string") {
      const s = v.trim().toLowerCase();
      if (s === "false" || s === "no" || s === "off" || s === "") {
        return false;
      }
      if (s === "true" || s === "yes" || s === "on") {
        return true;
      }
    }
    return Boolean(v);
  }

  /** Attribute defs for dropdowns: prefer API attributes[], else derive from variations[]. */
  function productAttributeDefs(product) {
    if (!product) {
      return [];
    }
    if (Array.isArray(product.attributes) && product.attributes.length) {
      return product.attributes.filter(
        (attr) =>
          attr &&
          attr.name &&
          Array.isArray(attr.values) &&
          attr.values.length,
      );
    }
    const variations = Array.isArray(product.variations) ? product.variations : [];
    const attrMap = {};
    variations.forEach((row) => {
      if (!row || !row.attributes || typeof row.attributes !== "object") {
        return;
      }
      Object.entries(row.attributes).forEach(([key, value]) => {
        const name = String(key).trim();
        const val = String(value).trim();
        if (!name || !val) {
          return;
        }
        if (!attrMap[name]) {
          attrMap[name] = new Set();
        }
        attrMap[name].add(val);
      });
    });
    return Object.keys(attrMap).map((name) => ({
      name,
      values: [...attrMap[name]],
    }));
  }

  function productHasOptions(product) {
    return productAttributeDefs(product).length > 0;
  }

  function findVariationRow(product, combo) {
    const variations = Array.isArray(product.variations) ? product.variations : [];
    if (!variations.length) {
      return null;
    }
    return (
      variations.find(
        (row) =>
          row &&
          row.attributes &&
          attrAssocMapsEqual(row.attributes, combo),
      ) || null
    );
  }

  function selectionValidation(state, index) {
    const selected = state.selections[index];
    const product = selectedProduct(state, index);
    if (!selected || !product) {
      return { complete: false, message: "" };
    }
    const defs = productAttributeDefs(product);
    if (!defs.length) {
      return { complete: true, message: "" };
    }
    const combo = selected.attributes || {};
    const allFilled = defs.every((def) => {
      const name = String(def.name);
      return combo[name] && combo[name] !== "";
    });
    if (!allFilled) {
      return { complete: false, message: "" };
    }
    const variations = Array.isArray(product.variations) ? product.variations : [];
    if (!variations.length) {
      return { complete: true, message: "" };
    }
    const row = findVariationRow(product, combo);
    if (!row) {
      return {
        complete: false,
        message: "These options could not be matched.",
      };
    }
    if (!rowIsEnabled(row)) {
      return {
        complete: false,
        message: "The selected option is not available.",
      };
    }
    return { complete: true, message: "" };
  }

  function syncBundleModalWidth(tabCount) {
    const container = modal.querySelector(".modal-container");
    if (!container) {
      return;
    }
    if (window.matchMedia("(max-width: 767.98px)").matches) {
      container.style.removeProperty("--bundle-modal-width");
      return;
    }

    const rootFont = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    const rem = (value) => value * rootFont;
    const count = Math.max(1, tabCount || 1);
    const baseWidth = 730;
    const maxWidth = window.innerWidth * 0.8;
    const summaryMin = rem(11.25);
    const gridGap = rem(2);
    const builderMin = rem(20.625);
    const builderPadding = rem(2);
    const tabStep = rem(7);
    const modalPadding = rem(5);
    const builderForTabs = count * tabStep + builderPadding;
    const contentWidth = summaryMin + gridGap + Math.max(builderMin, builderForTabs);
    const width = Math.min(maxWidth, Math.max(baseWidth, Math.round(contentWidth + modalPadding)));

    container.style.setProperty("--bundle-modal-width", `${width}px`);
  }

  function openBundle(bundle, options) {
    const settings = options || {};
    const state = {
      bundle,
      step: 0,
      selections: [],
      submitting: false,
      adopt: settings.adopt || null,
      // Opened from the drawer's upsell: Cart.js reopens the drawer on add
      // rather than showing the toast.
      fromDrawer: Boolean(settings.fromDrawer),
    };
    applyPrefill(state, settings.prefill);
    modal.classList.add("is-bundle-modal");
    if (window.ThemeJS && window.ThemeJS.Product_Modal) {
      window.ThemeJS.Product_Modal.open();
    } else {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      modal.removeAttribute("inert");
    }
    render(state);
    syncBundleModalWidth(bundle.categories.length);
  }

  /**
   * Seed selections from cart lines the offer is carrying across, then open on
   * the first category still to be chosen.
   */
  function applyPrefill(state, prefill) {
    if (!prefill || typeof prefill !== "object") {
      return;
    }
    state.bundle.categories.forEach((category, index) => {
      const seed = prefill[index] != null ? prefill[index] : prefill[String(index)];
      if (!seed) {
        return;
      }
      const product = (category.products || []).find(
        (p) =>
          String(p.parent_id) === String(seed.parent_id) &&
          String(p.name) === String(seed.name) &&
          String(p.price) === String(seed.price),
      );
      if (!product) {
        return;
      }
      state.selections[index] = {
        key: productKey(product),
        parent_id: product.parent_id,
        name: product.name,
        price: product.price,
        attributes: seed.attributes && typeof seed.attributes === "object" ? { ...seed.attributes } : {},
      };
    });

    // A gap means the prefill did not resolve; do not present later steps as
    // reachable when an earlier one is still empty.
    let firstGap = state.bundle.categories.length;
    for (let i = 0; i < state.bundle.categories.length; i += 1) {
      if (!selectionComplete(state, i)) {
        firstGap = i;
        break;
      }
    }
    state.selections = state.selections.slice(0, firstGap);
    state.step = Math.min(firstGap, state.bundle.categories.length - 1);
  }

  function selectedAt(state, index) {
    return state.selections[index] || null;
  }

  function selectedProduct(state, index) {
    const selected = selectedAt(state, index);
    if (!selected) {
      return null;
    }
    const category = state.bundle.categories[index];
    return (category.products || []).find((p) => productKey(p) === selected.key) || null;
  }

  function selectionComplete(state, index) {
    return selectionValidation(state, index).complete;
  }

  function resetFromStep(state, nextStep) {
    state.selections = state.selections.slice(0, nextStep);
    state.step = nextStep;
  }

  function renderCategoryTabs(state) {
    const categories = state.bundle.categories || [];
    return `
      <div class="commencement-bundle-tabs" role="group" aria-label="Bundle steps">
        ${categories
          .map((category, index) => {
            const isActive = index === state.step;
            const active = isActive ? " is-active" : "";
            const isComplete = selectionComplete(state, index);
            const complete = isComplete ? " is-complete" : "";
            const disabled = index > state.step && !selectionComplete(state, index - 1);
            const name = escapeHtml(category.name || `Step ${index + 1}`);
            const status = isComplete ? ", completed" : "";
            return `
              <button type="button" class="commencement-bundle-tab${active}${complete}" data-step="${index}" ${isActive ? 'aria-current="step"' : ""} ${disabled ? "disabled" : ""}>
                <span class="commencement-bundle-tab__dot" aria-hidden="true"></span>
                <span>${name}</span>
                <span class="sr-only">, step ${index + 1} of ${categories.length}${status}</span>
              </button>
            `;
          })
          .join("")}
      </div>
    `;
  }

  function renderAttributeSelects(product, selected) {
    const defs = productAttributeDefs(product);
    if (!defs.length) {
      return "";
    }
    const attrs = (selected && selected.attributes) || {};
    return `
      <div class="commencement-bundle-attrs">
        ${defs
          .map((attr) => {
            const name = String(attr.name);
            const values = Array.isArray(attr.values) ? attr.values : [];
            const placeholder = `Select a ${name.toLowerCase()}`;
            return `
              <label class="commencement-bundle-attr">
                <span class="screen-reader-text">${escapeHtml(name)}</span>
                <select class="commencement-bundle-attr-select" data-attr-name="${escapeHtml(name)}">
                  <option value="">${escapeHtml(placeholder)}</option>
                  ${values
                    .map((value) => {
                      const option = String(value);
                      return `<option value="${escapeHtml(option)}" ${attrs[name] === option ? "selected" : ""}>${escapeHtml(option)}</option>`;
                    })
                    .join("")}
                </select>
              </label>
            `;
          })
          .join("")}
      </div>
    `;
  }

  function renderProductOptions(state) {
    const category = state.bundle.categories[state.step];
    const current = selectedAt(state, state.step);
    const products = category.products || [];
    return `
      <div class="commencement-bundle-product-list">
        ${products
          .map((product) => {
            const key = productKey(product);
            const checked = current && current.key === key;
            const hasOptions = productHasOptions(product);
            const optionClasses = [
              "commencement-bundle-product-option",
              checked ? "is-selected" : "",
              hasOptions ? "has-options" : "",
            ]
              .filter(Boolean)
              .join(" ");
            return `
              <label class="${optionClasses}">
                <input type="radio" name="commencement_bundle_product" value="${escapeHtml(key)}" ${checked ? "checked" : ""}>
                <div class="commencement-bundle-product-option__row">
                  <img src="${escapeHtml(productImageUrl(product))}" alt="${escapeHtml(product.name)}" loading="lazy" decoding="async">
                  <span>${escapeHtml(product.name)}</span>
                </div>
                ${checked ? renderAttributeSelects(product, current) : ""}
              </label>
            `;
          })
          .join("")}
      </div>
    `;
  }

  function render(state) {
    const bundle = state.bundle;
    const category = bundle.categories[state.step];
    const isFinal = state.step === bundle.categories.length - 1;
    const complete = selectionComplete(state, state.step);
    const validation = selectionValidation(state, state.step);
    const image =
      bundle.picture ||
      (bundle.categories[0] &&
        bundle.categories[0].products[0] &&
        productImageUrl(bundle.categories[0].products[0])) ||
      placeholderImage;

    contentArea.innerHTML = `
      <div class="commencement-bundle-modal" data-step="${state.step}" data-tab-count="${bundle.categories.length}">
        <div class="commencement-bundle-modal__summary">
          <img src="${escapeHtml(image)}" alt="${escapeHtml(bundle.name)}" loading="lazy" decoding="async">
          <h2>${escapeHtml(bundle.name)}</h2>
          <p class="price">${moneyAmount(bundle.bundle_price ?? bundle.discount_price)}${currencyCodeHtml()}</p>
          ${bundle.description ? `<p>${escapeHtml(bundle.description)}</p>` : ""}
        </div>
        <div class="commencement-bundle-modal__builder">
          <h3>Create your bundle</h3>
          ${renderCategoryTabs(state)}
          <div class="commencement-bundle-step">
            <h4>${escapeHtml(category.name || "")}</h4>
            ${renderProductOptions(state)}
          </div>
          <p class="commencement-bundle-unavailable-msg" role="status" aria-live="polite" ${validation.message ? "" : "hidden"}>${escapeHtml(validation.message)}</p>
          <p class="commencement-bundle-error" role="status" aria-live="polite" hidden></p>
          <div class="commencement-bundle-actions">
            ${state.step > 0 ? '<button type="button" class="button commencement-bundle-prev">Previous</button>' : ""}
            <button type="button" class="button commencement-bundle-next" ${complete ? "" : "disabled"}>
              ${isFinal ? "Add Bundle to Cart" : "Next"}
            </button>
          </div>
        </div>
      </div>
    `;

    bindModalEvents(state);
    syncBundleModalWidth(state.bundle.categories.length);
  }

  function bindModalEvents(state) {
    contentArea.querySelectorAll(".commencement-bundle-tab").forEach((tab) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const nextStep = parseInt(tab.getAttribute("data-step") || "0", 10);
        if (Number.isNaN(nextStep) || nextStep === state.step || nextStep > state.step) {
          return;
        }
        resetFromStep(state, nextStep);
        render(state);
      });
    });

    contentArea
      .querySelectorAll('input[name="commencement_bundle_product"]')
      .forEach((radio) => {
        radio.addEventListener("change", () => {
          const category = state.bundle.categories[state.step];
          const product = (category.products || []).find(
            (p) => productKey(p) === radio.value,
          );
          if (!product) {
            return;
          }
          state.selections[state.step] = {
            key: radio.value,
            parent_id: product.parent_id,
            name: product.name,
            price: product.price,
            attributes: {},
          };
          state.selections = state.selections.slice(0, state.step + 1);
          render(state);
        });
      });

    contentArea
      .querySelectorAll(".commencement-bundle-attr-select")
      .forEach((select) => {
        select.addEventListener("change", () => {
          const selected = selectedAt(state, state.step);
          if (!selected) {
            return;
          }
          const attrName = select.getAttribute("data-attr-name");
          if (!selected.attributes) {
            selected.attributes = {};
          }
          if (select.value) {
            selected.attributes[attrName] = select.value;
          } else {
            delete selected.attributes[attrName];
          }
          state.selections = state.selections.slice(0, state.step + 1);
          render(state);
        });
      });

    const prev = contentArea.querySelector(".commencement-bundle-prev");
    if (prev) {
      prev.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        resetFromStep(state, Math.max(0, state.step - 1));
        render(state);
      });
    }

    const next = contentArea.querySelector(".commencement-bundle-next");
    if (next) {
      next.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!selectionComplete(state, state.step) || state.submitting) {
          return;
        }
        if (state.step < state.bundle.categories.length - 1) {
          state.step += 1;
          render(state);
          return;
        }
        await submitBundle(state);
      });
    }
  }

  async function submitBundle(state) {
    const btn = contentArea.querySelector(".commencement-bundle-next");
    const error = contentArea.querySelector(".commencement-bundle-error");
    state.submitting = true;
    if (btn) {
      btn.disabled = true;
      btn.classList.add("loading");
      btn.textContent = "Adding...";
    }
    if (error) {
      error.hidden = true;
      error.textContent = "";
    }

    const formData = new FormData();
    formData.set("action", "commencement_add_bundle_to_cart");
    formData.set("bundle_id", state.bundle.id);
    if (state.adopt && Object.keys(state.adopt).length) {
      formData.set("adopt", JSON.stringify(state.adopt));
    }
    formData.set(
      "items",
      JSON.stringify(
        state.selections.map((selection) => ({
          parent_id: selection.parent_id,
          name: selection.name,
          price: selection.price,
          attributes: selection.attributes || {},
        })),
      ),
    );
    const categoryCtx =
      typeof commencementModalCategoryContext === "function"
        ? commencementModalCategoryContext()
        : "";
    if (categoryCtx) {
      formData.set("category_context", categoryCtx);
    }

    try {
      const response = await fetch(getAjaxUrl(), {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (!response.ok || !data || data.success === false) {
        throw new Error(
          data && data.data && data.data.message
            ? data.data.message
            : "Could not add the bundle to cart.",
        );
      }
      if (data.fragments && typeof jQuery !== "undefined") {
        jQuery.each(data.fragments, (key, html) => {
          jQuery(key).replaceWith(html);
        });
        // Always notify so Cart.js can sync the bag badge (do not require cart_hash).
        jQuery(document.body).trigger("added_to_cart", [
          data.fragments,
          data.cart_hash || "",
          null,
          { name: state.bundle.name || "", fromDrawer: state.fromDrawer },
        ]);
      }
      if (window.ThemeJS && window.ThemeJS.Product_Modal) {
        window.ThemeJS.Product_Modal.close();
      } else {
        modal.classList.remove("is-open", "is-bundle-modal");
        modal.querySelector(".modal-container")?.style.removeProperty("--bundle-modal-width");
        contentArea.innerHTML = "";
      }
    } catch (err) {
      if (error) {
        error.textContent = err && err.message ? err.message : "Could not add the bundle.";
        error.hidden = false;
      }
    } finally {
      state.submitting = false;
      if (btn) {
        btn.classList.remove("loading");
        btn.disabled = !selectionComplete(state, state.step);
        btn.textContent = "Add Bundle to Cart";
      }
    }
  }

  document.body.addEventListener("click", (event) => {
    const trigger = event.target.closest(".commencement-build-bundle");
    if (!trigger) {
      return;
    }
    event.preventDefault();
    const bundle = bundleById.get(String(trigger.getAttribute("data-bundle-id")));
    if (bundle) {
      openBundle(bundle);
    }
  });

  /**
   * Mini-cart upsell. Its payload ships inside the cart fragment, so it is read
   * at click time rather than cached - the fragment is replaced on every cart
   * change and the offer changes with it.
   */
  document.body.addEventListener("click", (event) => {
    const trigger = event.target.closest(".commencement-bundle-upsell");
    if (!trigger) {
      return;
    }
    event.preventDefault();
    const payloadEl = document.getElementById("commencement-bundle-upsell-data");
    if (!payloadEl) {
      return;
    }
    let payload;
    try {
      payload = JSON.parse(payloadEl.textContent || "{}");
    } catch (err) {
      console.warn("[commencement bundle] upsell JSON parse error", err);
      return;
    }
    if (!payload || !payload.bundle || !Array.isArray(payload.bundle.categories)) {
      return;
    }
    if (payload.placeholder_image) {
      placeholderImage = String(payload.placeholder_image);
    }
    showCadCurrency = Boolean(payload.show_cad_currency);
    // Close the drawer first: it returns focus to the cart trigger on close, so
    // doing it after openBundle would pull focus back out of the modal.
    if (window.ThemeJS && window.ThemeJS.Cart) {
      window.ThemeJS.Cart.close();
    }
    openBundle(payload.bundle, {
      prefill: payload.prefill,
      adopt: payload.adopt,
      fromDrawer: true,
    });
  });

  let resizeTimer;
  window.addEventListener("resize", () => {
    if (!modal.classList.contains("is-bundle-modal")) {
      return;
    }
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const modalRoot = contentArea.querySelector(".commencement-bundle-modal");
      const tabCount = modalRoot
        ? parseInt(modalRoot.getAttribute("data-tab-count") || "0", 10)
        : 0;
      if (tabCount > 0) {
        syncBundleModalWidth(tabCount);
      }
    }, 100);
  });
}

document.addEventListener("DOMContentLoaded", initCommencementBundleModal);
